import React from "react";
import {
  FaUpload,
  FaBookOpen,
  FaUsers,
  FaStar,
  FaMoneyBillWave,
  FaListAlt,
  FaChalkboardTeacher,
  FaClipboardList,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const InstructorHome = () => {
  // Dummy data — replace with your real API/fetch data
  const stats = {
    coursesSold: 128,
    rating: 4.8,
    earnings: 15320,
  };
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-indigo-100 p-8">
      <h1 className="text-4xl font-extrabold text-indigo-700 mb-8 tracking-wide">
        Welcome Back, Instructor!
      </h1>

      {/* Stats Section */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-12">
        <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-3 hover:shadow-indigo-400 transition">
          <FaBookOpen className="text-indigo-600 text-5xl" />
          <h3 className="text-xl font-semibold">Courses Sold</h3>
          <p className="text-indigo-800 text-3xl font-bold">
            {stats.coursesSold}
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-3 hover:shadow-yellow-400 transition">
          <FaStar className="text-yellow-400 text-5xl" />
          <h3 className="text-xl font-semibold">Average Rating</h3>
          <p className="text-yellow-600 text-3xl font-bold">
            {stats.rating} / 5
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-3 hover:shadow-green-400 transition">
          <FaMoneyBillWave className="text-green-600 text-5xl" />
          <h3 className="text-xl font-semibold">Total Earnings</h3>
          <p className="text-green-700 text-3xl font-bold">
            ₹ {stats.earnings.toLocaleString()}
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-wrap gap-6 mb-12 justify-center">
        <button
          className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition"
          onClick={(e) => {
            navigate("/upload-course");
          }}
        >
          <FaUpload /> Upload New Course
        </button>
        <button
          className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition"
          onClick={() => {
            navigate("/manage-my-courses");
          }}
        >
          <FaListAlt /> Manage My Courses
        </button>
        <button
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition"
          onClick={() => {
            navigate("/my-students");
          }}
        >
          <FaUsers /> My Students
        </button>
        <button className="flex items-center gap-2 bg-pink-600 hover:bg-pink-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition">
          <FaChalkboardTeacher /> Explore Instructors
        </button>
      </div>

      {/* Other Features Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-5xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-indigo-300 transition cursor-pointer">
          <div className="flex items-center gap-3 mb-4">
            <FaBookOpen className="text-indigo-600 text-3xl" />
            <h3 className="text-xl font-semibold">Courses</h3>
          </div>
          <p className="text-gray-700">
            Create and update your courses. Add modules and chapters to keep
            your content organized.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-yellow-300 transition cursor-pointer">
          <div className="flex items-center gap-3 mb-4">
            <FaClipboardList className="text-yellow-500 text-3xl" />
            <h3 className="text-xl font-semibold">Modules & Chapters</h3>
          </div>
          <p className="text-gray-700">
            Easily manage course modules and chapters. Structure your content
            for the best learner experience.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-green-300 transition cursor-pointer">
          <div className="flex items-center gap-3 mb-4">
            <FaMoneyBillWave className="text-green-600 text-3xl" />
            <h3 className="text-xl font-semibold">Earnings Overview</h3>
          </div>
          <p className="text-gray-700">
            Track your sales, revenue, and payouts all in one place.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InstructorHome;
